import React from 'react';
import css from './index.module.scss';
import { graphql, PageProps } from 'gatsby';
import { Layout } from '../../components/Layout';
import { ArticleLink } from '../../components/ArticleLink';
import { BlogIndexPageQuery } from '../../../graphql-types';

interface BLogIndexPageProps extends PageProps<BlogIndexPageQuery> {}

const BlogIndexPage = (props: BLogIndexPageProps) => {
  const posts = props.data.allMdx.edges;

  return (
    <Layout title="Blog">
      <ul className={css.articles}>
        {posts.map(({ node }) => (
          <ArticleLink
            key={node.fields.slug}
            title={node.frontmatter.title ?? node.fields.slug}
            date={node.frontmatter.date}
            description={node.frontmatter.description ?? node.excerpt}
            slug={node.fields.slug}
            subtitle={node.frontmatter.subtitle}
            imgUrl={node.frontmatter.heroImg}
            imgFit={node.frontmatter.imgFit}
            imgColor={node.frontmatter.theme}
          />
        ))}
      </ul>
    </Layout>
  );
};

export default BlogIndexPage;

export const pageQuery = graphql`
  query BlogIndexPage {
    site {
      siteMetadata {
        title
      }
    }
    allMdx(
      filter: { fileAbsolutePath: { regex: "//content/blog/" } }
      sort: { fields: frontmatter___date, order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            subtitle
            heroImg
            heroDevice
            imgFit
            theme
          }
          fileAbsolutePath
        }
      }
    }
  }
`;
